import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Bell Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-bell-outline',
    templateUrl: './icon-bell-outline.component.html',
    styleUrls: ['./icon-bell-outline.component.scss'],
    standalone: false
})
export class IconBellOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
